"use strict";
/**
 * Prefix example: +34, +235 || 34, 235 || 0034, 00235
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixValidator = void 0;
exports.prefixValidator = /^[+]?0{0,2}[0-9]{1,4}$/;
